import React from 'react';
import PropTypes from 'prop-types';
import './TaskUndoToast.css';

/**
 * Today's (v1) "Task completed · Undo" toast: the Task Board's, shared with
 * the unit Activity tab (D11). The live region is always mounted so screen
 * readers hear each new message; the toast never takes focus. State and the
 * 6 s timeout come from hooks/useUndoToast.
 */
function TaskUndoToast({ toast, onUndo, onDismiss }) {
    return (
        <div className="task-toast-region" role="status" aria-live="polite">
            {toast && (
                <div className="task-toast" key={toast.key}>
                    <span className="task-toast-text">{toast.text}</span>
                    <button type="button" className="task-toast-undo" onClick={onUndo}>Undo</button>
                    <button type="button" className="task-toast-close" aria-label="Dismiss" onClick={onDismiss}>
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
            )}
        </div>
    );
}

TaskUndoToast.propTypes = {
    toast: PropTypes.shape({ key: PropTypes.number.isRequired, text: PropTypes.node.isRequired }),
    onUndo: PropTypes.func.isRequired,
    onDismiss: PropTypes.func.isRequired,
};

export default TaskUndoToast;
